// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__17Lup","title":"Images90_title__kHyBS","images":"Images90_images__2R4sH"};